module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/tag-fb925ff1aac0da856688a8ba0dc1029c.svg";